import { render, staticRenderFns } from "./input-money.vue?vue&type=template&id=09ddc6c4&scoped=true"
import script from "./input-money.vue?vue&type=script&lang=js"
export * from "./input-money.vue?vue&type=script&lang=js"
import style0 from "./input-money.vue?vue&type=style&index=0&id=09ddc6c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ddc6c4",
  null
  
)

export default component.exports